import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { useAppStore } from 'hooks/state/useAppStore';
import { useFilterSetsSessionStore } from 'hooks/state/usePersistedStore';
import { Button } from 'components/Button';

export function ClearTradingFilterButton() {
  const { brands, categories, countries, marketplaces, setBrands, setCategories, setCountries, setMarketplaces } =
    useAppStore();

  const { setSelectedFilterSet, setLastClickedFilterSet } = useFilterSetsSessionStore();

  const hasFilters = useMemo(
    () =>
      (countries ?? []).length > 0 ||
      (categories ?? []).length > 0 ||
      (brands ?? []).length > 0 ||
      (marketplaces ?? []).length > 0,
    [countries, categories, brands, marketplaces]
  );

  const clearFilters = () => {
    setBrands([]);
    setCategories([]);
    setCountries([]);
    setMarketplaces([]);
    setSelectedFilterSet(null);
    setLastClickedFilterSet(null);
  };

  return (
    <div>
      {hasFilters && (
        <Button iconLeft="Cross" id="clear-all-filters-button" priority="ghost" onClick={clearFilters}>
          <FormattedMessage id="general.button.clear.all" />
        </Button>
      )}
    </div>
  );
}
